import React, { useEffect } from 'react';
import { pick } from 'ramda';
import { Loader } from 'js/components/common/Loader';
import { WebContent } from 'js/components/system/WebContent';
import { useMyAccountSidebarSelector } from 'js/store/hooks';

import { Menu } from '../Menu';
import * as hooks from './hooks';

export const HomePage = () => {
    const [getSidebarData, isLoading] = hooks.useGetSidebarData();
    const { headerWcId, footerWcId } = useMyAccountSidebarSelector(pick(['headerWcId', 'footerWcId']));

    useEffect(() => {
        getSidebarData();
    }, [getSidebarData]);

    if (isLoading) {
        return <Loader />;
    }

    return (
        <>
            <WebContent showLoader={false} id={headerWcId} />
            <Menu />
            <WebContent showLoader={false} id={footerWcId} />
        </>
    );
};
